module.exports = __webpack_public_path__ + "static/media/device_icon.e0fcb233.svg";